<template>
  <q-dialog
    :ref="$options.name"
    seamless
    position="bottom"
    class="action-outcome-alert"
  >
    <q-card class="action-outcome-alert__card">
      <q-card-section class="flex items-center no-wrap">
        <!--<q-icon :name="icon" :class="iconClass" class="q-mr-md" size="2em" />-->
        <h6 class="text-weight-medium q-mb-none">
          {{ message }}
        </h6>

        <q-space />

        <q-btn
          flat
          round
          dense
          icon="sym_r_close"
          color="text-text-light"
          class="q-ml-lg --bordered"
          v-close-popup
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "ActionOutcomeAlert",
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    /*icon() {
      let icon = this.success ? "sym_r_task_alt" : "sym_r_error_outline";
      if (this.type === "copy") {
        icon = "sym_r_content_copy";
      }
      return icon;
    },
    iconClass() {
      return this.success ? "text-positive" : "text-negative";
    }*/
  },
  methods: {
    show() {
      this.$refs[this.$options.name].show();
      setTimeout(() => {
        this.hide();
      }, 5000);
    },
    hide() {
      if (this.$refs[this.$options.name]) {
        this.$refs[this.$options.name].hide();
      }
    },
    handleOkClick() {
      this.$emit("ok");
      this.hide();
    }
  }
};
</script>

<style scoped lang="scss">
.action-outcome-alert {
  .action-outcome-alert__card {
    background: color(background, very-light);
    border: 1px solid color(border);
    box-shadow: $shadow-bottom, $shadow-top;
    border-radius: 12px;
    margin-bottom: $space-lg;
    border-left: 4px solid color(secondary);
  }
}
</style>
